import cn from '@/lib/cs';

const LargeSquareBackground = ({
	className,
	image,
}: {
	className?: string;
	image?: {
		base64: string;
		alt: string;
	};
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 675 654"
		className={cn(
			'absolute inset-0 size-full pointer-events-none',
			className,
		)}
		preserveAspectRatio="none">
		{!!image && (
			<>
				<title>{image.alt}</title>
				<defs>
					<pattern
						id="image"
						patternUnits="userSpaceOnUse"
						width="100%"
						height="100%">
						<image
							xlinkHref={image.base64}
							width="100%"
							height="100%"
							preserveAspectRatio="xMidYMid slice"
						/>
					</pattern>
				</defs>
			</>
		)}
		<path
			fill={image ? 'url(#image)' : 'currentColor'}
			d="M605 73C512 17 410-4 295 1 236 4 46 37 28 87c-38 121-48 407 38 498 98 101 473 85 554-10 61-74 91-442-15-502Z"
		/>
	</svg>
);

export const LargeSquareBackgroundLine = ({
	className,
}: {
	className?: string;
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 611 592"
		className={cn(
			'absolute inset-0 size-full pointer-events-none',
			className,
		)}
		preserveAspectRatio="xMidYMid meet">
		<path
			stroke="currentColor"
			strokeDasharray="12 64"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="14"
			d="M543 71C460 21 370 2 268 7 215 9 47 39 31 83-3 190-12 444 65 525c87 90 419 75 491-9 54-66 81-392-13-445Z"
		/>
	</svg>
);

export const LargeSquareDividerLine = ({
	className,
}: {
	className?: string;
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 675 654"
		className={cn(
			'absolute inset-0 size-full pointer-events-none',
			className,
		)}
		preserveAspectRatio="xMidYMid meet">
		<path
			stroke="url(#paint0_linear_1028_9568)"
			strokeDasharray="16 64"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="14"
			d="M543 150C501 170.5 413.481 184.346 412.005 282.951C410.529 381.556 339.589 415.44 272.708 415.44C161.296 415.44 166.5 483 147.709 517"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_1028_9568"
				x1="543"
				y1="150"
				x2="233.5"
				y2="426.5"
				gradientUnits="userSpaceOnUse">
				<stop
					offset="0.3"
					stopColor="currentColor"
					stopOpacity="1"
					style={{ stopColor: 'currentColor', stopOpacity: 1 }}
				/>
				<stop
					offset="0.7"
					stopColor="currentColor"
					stopOpacity="0.6"
					style={{ stopColor: 'currentColor', stopOpacity: 0.6 }}
				/>
				<stop
					offset="1"
					stopColor="currentColor"
					stopOpacity="0"
					style={{ stopColor: 'currentColor', stopOpacity: 0 }}
				/>
			</linearGradient>
		</defs>
	</svg>
);

export default LargeSquareBackground;
